import React from 'react';
import { Alert, Box, Button, Grid, Typography, lighten, useTheme } from '@mui/material';
import { CopyToClipboardButton } from '@lp/lp-ui';
import { InvitationResponseModel } from '../../typings';
import { GetLocalDateTimeString } from '../../DateUtilities';

interface InvitationResultPanelProps {
    result: InvitationResponseModel,
    resending: boolean,
    onResend: () => void
}

const InvitationResultPanel: React.FC<InvitationResultPanelProps> = ({ result, resending, onResend }) => {
    const theme = useTheme();
    const expires = result.expiresUtc ? GetLocalDateTimeString(new Date(result.expiresUtc)) : '';

    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                {result.url
                    ? <Alert severity="success">
                        Invitation sent to {result.email}. The link expires {expires}.
                    </Alert>
                    : <Alert severity="warning">
                        The invitation for {result.email} was created, but no link was issued.
                    </Alert>
                }
            </Grid>
            {result.warnings.map((warning, i) => (
                <Grid item xs={12} key={i}>
                    <Alert severity="warning">{warning}</Alert>
                </Grid>
            ))}
            {result.url &&
                <Grid item xs={12}>
                    <Typography marginBottom={1}>Invitation link:</Typography>
                    <Box display="flex" flexDirection="row" alignItems="center">
                        <Box component="span" pt={0.5} pb={0.5} pl={1} pr={1} border="solid 1px" borderRadius={1}
                            bgcolor={lighten(theme.palette.primary.light, 0.5)} sx={{ wordBreak: 'break-all' }}>
                            {result.url}
                        </Box>
                        <CopyToClipboardButton text={result.url} size="small" />
                    </Box>
                    <Typography marginTop={1} variant="body2" color="text.secondary">
                        This is the only time the link is shown. Anyone who holds it can set this user's password.
                    </Typography>
                </Grid>
            }
            <Grid item xs={12}>
                <Box display="flex" justifyContent="flex-end" alignItems="center" gap={2}>
                    <Typography variant="body2" color="text.secondary">
                        Resend issues a new link. The earlier link will no longer work.
                    </Typography>
                    <Button variant="contained" color="primary" onClick={onResend} disabled={resending}>
                        Resend
                    </Button>
                </Box>
            </Grid>
        </Grid>
    );
};

export default InvitationResultPanel;
